export default {
    auth: {
        signOut: "Чыгуу",
        signIn: "Кирүү"
    },
    roles: {
        roles: "Ролдор",
        save: "Сактоо",
        cancel: "Баш тартуу"
    },
    app: {
        home: "Башкы бет",
        saveSuccessMsg: "Сакталды!"
    },
    datePicker: {
        mon: "Дш",
        tue: "Шш",
        wed: "Шр",
        thu: "Бш",
        fri: "Жм",
        sat: "Иш",
        sun: "Жш",
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь",
        nextMonth: "Кийинки ай",
        prevMonth: "Мурунку ай",
        setTime: "Убакытты көрсөтүү",
        format: "кк.аа.жжжж"
    },
}